module.exports = __webpack_public_path__ + "img/regulation-white.248f842a.svg";